import React from 'react';
import {toast, Toaster} from "react-hot-toast";

const CustomToaster = () => {
    return <Toaster position="top-right"/>
}

export const showError = (message) => {
    toast.error(message, {
        duration: 5000,
        style: {
            borderRadius: '10px',
            background: '#0d1526',
            color: '#fff',
        },
    });
}

export const showSuccess = (message) => {
    toast.success(message, {
        duration: 5000,
        style: {
            borderRadius: '10px',
            background: '#0d1526',
            color: '#fff',
        },
    });
}

export default CustomToaster;
